import { render, staticRenderFns } from "./AddParamToDashboard.vue?vue&type=template&id=4e71d855"
import script from "./AddParamToDashboard.vue?vue&type=script&lang=js"
export * from "./AddParamToDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports